module.exports = __webpack_public_path__ + "img/clone_troopers.17d23566.webp";